import $ from 'jquery';
import './global.css';
const global = {};
layui.use(['element', 'laypage'], () => {
    const element = layui.element;
    var laypage = layui.laypage;

    //分页
    laypage.render({
        elem: 'pagination', //注意，这里的 test1 是 ID，不用加 # 号
        curr: location.href.indexOf('page') !== -1 ? location.href.match(/page=([\d]+)/)[1] : 1,
        prev: '<<',
        next: '>>',
        first: '首页',
        last: '尾页',
        layout: ['first', 'prev', 'page', 'next', 'last'], // 分页元素顺序
        count: $('#pagination').data('count'), //数据总数，从前端元素中获取，需要在模板文件中生成
        jump: function (obj, first) {
            //首次不执行
            if (!first) {
                const currentUrl = location.href;
                if (currentUrl.indexOf('page=') === -1) {
                    location.href = currentUrl + `&page=${obj.curr}`;
                } else {
                    location.href = currentUrl.replace(/(page=)[\d]+/, `$1${obj.curr}`);
                }
            }
        },
    });

    $('.header-nav-btn i').on('click', (_this, el) => {
        const navEl = $('.layui-nav');
        navEl.css({ top: $('.header-nav-btn').offset().top - 60 })
        navEl.fadeToggle();
    })

    // 当窗体大小发生改变
    $(window).on('resize', () => {
        changeNav();
    })

    changeNav(); // 初始化导航菜单
    function changeNav() {
        const navChilds = $('.layui-nav').children('.layui-nav-item');
        const cateCount = navChilds.length;
        // 当屏幕是手机大小时 切换导航样式
        if ($(window).width() < 768) {
            // 当屏幕为手机屏幕
            if (!$('.layui-nav').hasClass('layui-nav-tree')) {
                navChilds.css('width', 'auto');
                $('.header-nav-btn').show();
                $('.layui-nav').addClass('layui-nav-tree').css('position', 'absolute').hide();
                element.render();
            }
        } else {
            if ($('.layui-nav').hasClass('layui-nav-tree')) {
                // 移除手机样式
                $('.layui-nav').removeClass('layui-nav-tree').css('position', 'static').show().find('.layui-nav-itemed').removeClass('layui-nav-itemed');
                $('.header-nav-btn').hide();
                element.render();
            }
            // 调整菜单栏元素宽度
            const nowWidth = $('.layui-nav').width();
            navChilds.width(`${nowWidth / cateCount}px`);
        }
    }
})

export default global;